import React from 'react'
import { Box, Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { NavLink } from 'react-router-dom'
import { AnimatedSection, AnimatedTableRow } from '../animations/MotionContainers'

export const ActivityTable = ({ title, rows, footer, footerPath, emptyMessage = 'No hay actividad reciente.' }) => (
  <AnimatedSection>
    <Card className="activity-card">
      <CardContent>
        <Typography className="section-title">{title}</Typography>
        <Box className="activity-table-wrap">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Aplicacion</TableCell>
                <TableCell>Fecha y hora</TableCell>
                <TableCell>Accion</TableCell>
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={`${row.app}-${row.date}-${row.action}`} component={AnimatedTableRow} hover>
                  <TableCell>
                    <Box className="activity-app-cell">
                      <Box className="activity-row-icon">{row.icon}</Box>
                      <Typography>{row.app}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.action}</TableCell>
                  <TableCell align="right">
                    <ArrowForwardRoundedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                  </TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography className="admin-user-empty">{emptyMessage}</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
        {footer && (
          <Box
            component={footerPath ? NavLink : 'div'}
            to={footerPath || undefined}
            className="activity-footer"
          >
            <Typography>{footer}</Typography>
            <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
          </Box>
        )}
      </CardContent>
    </Card>
  </AnimatedSection>
)
